import useAuthApi from "../helpers/authHook";

export const requestRouteService = {
  getAll,
  approve,
  reject,
  transform,
  getAllStops,              
  updateRequestRouteStops,
};

async function getAll() {
  try {
    const privateAuth = useAuthApi();
    const response = await privateAuth.get("routeRequests");
    // console.log("data: ", response.data);
    // Ensure we always return an array
    return Array.isArray(response.data.data) ? response.data.data : [];
  } catch (e) {
    console.error("Error fetching route requests:", e);
    // Return empty array on error to prevent rows.map crash
    return [];
  }
}

async function approve(id) {
  try {
    const privateAuth = useAuthApi();
    const response = await privateAuth.put(`routeRequests/approve/${id}`);
    return response.data;
  } catch (e) {
    console.error("Error approving route:", e);
    return e.response || null;
  }
}

async function reject(id) {
  try {
    const privateAuth = useAuthApi();
    const response = await privateAuth.put(`routeRequests/reject/${id}`);
    return response.data;
  } catch (e) {
    console.error("Error rejecting route:", e);
    return e.response || null;
  }
}


// Fetch all stops for a request route
async function getAllStops(requestId) {
  try {
    const privateAuth = useAuthApi();

    const response = await privateAuth.get(
      `routeRequests/stops/${requestId}`
    );

    // backend returns { message, data }
    return response.data;
  } catch (e) {
    console.error("Error fetching stops:", e);
    return null;
  }
}


// Save pickup & dropoff stop titles
async function updateRequestRouteStops(requestId, payload) {
  try {
    // console.log("Updating stops with payload:", payload);
    const privateAuth = useAuthApi();
    const response = await privateAuth.put(
      `routeRequests/stops/${requestId}`,
      payload
    );
    return response.data;
  } catch (e) {
    console.error("Error updating stops:", e);
    return e.response || null;
  }
}

function transform(rows = []) {
  // Ensure rows is always an array
  return rows.map((item, i) => {
    const home = item.userId?.places?.home || {};
    const office = item.userId?.places?.office || {};

    // const reqPickup = item.places?.pickupPoint || {};
    // const reqDrop = item.places?.dropoffPoint || {};

    return {
      id: i + 1,
      _id: item._id,
      routeId_title: item.routeId?.title || "-",
      userId_fullname: `${item.userId?.firstname || ""} ${item.userId?.lastname || ""}`.trim() || "-",
      userId_email: item.userId?.email || "-",
      userId_phone: item.userId?.phone || "-",

      user_pickup_stop: home.coordinates || null,
      user_drop_stop: office.coordinates || null,
      user_pickup_address: home.address || "-",
      user_drop_address: office.address || "-",

      pickupStopTitle: item.pickupStopTitle || "",
      dropoffStopTitle: item.dropoffStopTitle || "",
      pickup_address: item.pickup_address || "-",
      drop_address: item.drop_address || "-",
      pickup_coordinates: item.pickup_coordinates || null,
      drop_coordinates: item.drop_coordinates || null,

    };
  });
}


